import { PriceMoney } from "@/modules/location";
import { OocTabItemType } from "@/types/app/ooc/tab-item.type";
import OocTabItemInterface from "@/interface/app/ooc/tab-item.interface";
import { ExtraCharge } from "@/modules/business/extra-charges";
import { TabItemModifier } from "@/modules/ooc/tab-item-modifier";

export class OocTabItem implements OocTabItemInterface {
  id: string = "";
  name: string = "";
  quantity: number = 0;
  variation: any;
  modifiers: Array<any> = [];
  discounts: Array<any> = [];
  price: string = new PriceMoney({ amount: 0 }).getPricePackage();
  totalPrice: string = new PriceMoney({ amount: 0 }).getPricePackage();
  variationName: string = "";
  constructor(data: OocTabItemType) {
    if (data) {
      this.id = data.id;
      this.name = data.name;
      this.quantity = data.quantity;
      this.variation = data.variation;
      this.price = new PriceMoney({ amount: data.variation?.price }).getPricePackage();
      this.totalPrice = new PriceMoney({ amount: data.variation?.price * this.quantity }).getPricePackage();
      this.modifiers = data.modifiers.map((modifier) => new TabItemModifier(modifier)) || [];
      this.discounts = data.discounts.map((discount) => new ExtraCharge(discount)) || [];
      this.variationName = data.variation?.name || "";
    }
  }
}
